<!--
 * @Author: your name
 * @Date: 2021-11-15 15:42:40
 * @LastEditTime: 2021-11-22 14:19:53
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /ark-student-wap/src/pages/arkHome/components/association.vue
-->
<!--  -->
<template>
  <div class="">
    <van-popup v-model="show" position="bottom" duration="0.18" round @click-overlay="close">
      <div class="title">
        <div class="title-left">
          <img src="@/assets/img/loginImg/group-step.png" alt="" />
        </div>
        <div class="title-txt">
          <h1>课程预约成功</h1>
          <h2>{{ currentCommunity.title }}</h2>
        </div>
      </div>
      <div class="group-content">
        <img v-if="communityInfo.accountType" class="qrocde" :src="communityInfo.qrcode" alt="" />
        <img
          v-else
          class="qrocde"
          src="https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/tencentQrcode.png"
          alt=""
        />
        <p>
          {{ !isWechatBrowser ? currentCommunity.desc : currentCommunity.miniDesc }}
        </p>
        <!-- 请截图保存二维码到微信添加 -->
      </div>
      <button class="btn" v-if="isWechatBrowser && currentCommunity.miniBtnText">
        {{ currentCommunity.miniBtnText }}
      </button>
      <button class="btn" v-if="!isWechatBrowser" @click="oepnCommniuty">
        {{ currentCommunity.btnText }}
      </button>
    </van-popup>
    <RemindBox v-if="isRemindBox" @closeRemindBox="closeRemindBox" />
  </div>
</template>

<script>
import { reqCourseCommunitySku } from '@/api/courseDetail/community/community';
import RemindBox from '@/components/remindBox/index.vue';
import { miniSchemeUrl } from '@/utils/common';

// import { copyTool } from '@/utils/tools';

export default {
  components: {
    RemindBox,
  },
  data() {
    return {
      show: false,
      isRemindBox: false,
      communityInfo: {},
      qc_code_url: 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/tencentQrcode.png',
      textConfig: {
        account: {
          title: '关注官方公众号，享更多福利',
          desc: '点击下方按钮即可添加',
          miniDesc: '上按上方二维码，关注服务号',
          btnText: ' 立即关注 ',
          miniBtnText: '',
        },
        '1-1': {
          // qq 群
          desc: '点击下方按钮即可添加',
          miniDesc: '请长按上方二维码保存图片，前往QQ扫描二维码添加',
          title: '加入学习群，领取更多学习资料',
          btnText: '立即前往QQ添加',
          miniBtnText: '',
        },
        '1-2': {
          // qq 个人
          desc: '点击下方按钮即可添加',
          miniDesc: '请长按上方二维码保存图片，前往QQ扫描二维码添加',
          title: '添加老师QQ，享受课程服务',
          btnText: '立即前往QQ添加',
          miniBtnText: '',
        },
        '2-1-1': {
          // 微信-群-保存二维码
          desc: ' 请截图保存二维码到微信添加',
          miniDesc: '请长按上方二维码，添加微信群',
          title: '加入学习群，领取更多学习资料',
          btnText: ' 立即加入 ',
          miniBtnText: '',
        },
        '2-2-1': {
          // 微信-个人-保存二维码
          desc: ' 请截图保存二维码到微信添加 ',
          miniDesc: '请长按上方二维码，添加微信号',
          title: '添加老师微信，享受课程服务',
          btnText: ' 立即加入 ',
          miniBtnText: '',
        },
        '2-1-3': {
          // 微信-群-跳转小程序
          desc: '点击下方按钮，立即添加',
          miniDesc: '请长按上方二维码，添加微信群',
          title: '加入学习群，领取更多学习资料',
          btnText: '前往微信添加',
          miniBtnText: '',
        },

        '2-2-3': {
          // 微信-个人-跳转小程序
          desc: '点击下方按钮，立即添加',
          miniDesc: '请长按上方二维码，添加微信号',
          title: '添加老师微信，享受课程服务',
          btnText: '前往微信添加',
          miniBtnText: '',
        },
      },
      isWechatBrowser: /MicroMessenger/i.test(navigator.userAgent),
      currentCommunity: {},
    };
  },
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.getCourseCommunitySku();
  },
  methods: {
    showRemindBox() {
      // 打开开播提醒
      this.isRemindBox = true;
    },
    closeRemindBox() {
      // 关闭开播提醒
      this.isRemindBox = false;
    },
    async getCourseCommunitySku() {
      const { productId, productSkuSimpleVOS } = this.courseInfo;
      const request = await reqCourseCommunitySku(productId, productSkuSimpleVOS[0].productSkuId);
      this.show = true;
      this.currentCommunity = this.textConfig['account'];
      if (request?.code === 0 && request?.data) {
        const { platform, accountType, qrcode, linkUrl, groupEntryMode } = request.data;
        if (platform === 1) {
          this.currentCommunity = this.textConfig[`${platform}-${accountType}`];
        } else if (platform === 2) {
          this.currentCommunity = this.textConfig[`${platform}-${accountType}-${groupEntryMode}`];
        }
        console.log(this.currentCommunity, 9999000);
        Object.assign(this.communityInfo, {
          ...request.data,
        });
      }
    },
    btnStatus() {
      const { accountType, platform, groupEntryMode } = this.communityInfo;
      let text = '';
      if (platform === 2 && groupEntryMode === 3) {
        text = '前往微信添加';
      } else if (accountType === 1) {
        text = '立即加入';
      } else if (accountType === 2) {
        text = '立即添加';
      } else {
        text = '立即关注';
      }
      return text;
    },
    close() {
      this.$emit('closeGroup', true);
      this.show = false;
    },
    // 打开微信小程序加群页
    async jumpMini() {
      const { communityId } = this.communityInfo || {};
      const schemeLink = await miniSchemeUrl(
        'wxdb89cfa2bb60f779',
        '/subPackages/codePage/codePage',
        `communityId=${communityId||""}`,
      );
      window.location.href = schemeLink;
    },
    oepnCommniuty() {
      const { platform } = this.communityInfo;
      if (platform === 2) {
        this.jumpWX();
      } else if(platform === 1) {
        this.jumpQQ();
      }else{
        this.jumpMini()
      }
    },
    // 微信
    jumpWX() {
      const { platform, groupEntryMode } = this.communityInfo;
      if (platform === 2 && groupEntryMode === 3) {
        this.jumpMini();
        return;
      }
      this.$toast('正在打开微信');
      setTimeout(() => {
        window.location.href = 'weixin://';
      }, 500);
    },
    // qq群
    jumpQQ() {
      const { linkUrl } = this.communityInfo;
      if (linkUrl) {
        window.location.href = linkUrl;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .van-popup--round {
  border-radius: 18px;
}
.title {
  display: flex;
  justify-content: flex-start;
  padding: 62px 47px 37px 47px;
  .title-left {
    > img {
      width: 43px;
      height: 170px;
    }
  }
  .title-txt {
    padding: 8px 0 0 33px;
    h1,
    h2 {
      color: #333;
      font-weight: 600;
      font-size: 33px;
    }
    h1 {
      padding-bottom: 90px;
    }
  }
}
.group-content {
  .qrocde {
    display: block;
    width: 290px;
    height: 290px;
    margin: 0 auto;
  }
  .official {
    display: flex;
    justify-content: space-between;
    padding: 20px 85px 50px 85px;
    img {
      width: 141px;
      height: 141px;
    }
    p {
      padding-top: 20px;
      color: #333;
      font-weight: 400;
      font-size: 29px;
    }
  }
  > p {
    padding: 29px 0 29px 0;
    color: #787878;
    font-weight: 400;
    font-size: 25px;
    text-align: center;
  }
}
.btn {
  display: block;
  width: 634px;
  height: 91px;
  margin: 0 auto 40px;
  color: #fff;
  font-weight: 500;
  font-size: 36px;
  background: #ff6c02;
  border-radius: 45px;
}
</style>
